import AnalyticsActions, { analyticsActionTypes } from '@Actions/application/analyticsActions';
import TrackerActions from '@Actions/trackerActions';
import {
  put, takeEvery, all, select
} from 'redux-saga/effects';
import { notification } from 'antd';
import AnalyticsServices from '@Services/application/analyticsServices';

/**
 *
 * @param action
 * @returns {Generator<*, void, *>}
 * @private
 */
function* _getAnalytics(action) {
  const { dataType, name, params } = action;
  try {
    yield put(AnalyticsActions.getAnalyticsDataLoading(dataType, name, true));
    let data = null;

    // Purchase
    if (dataType === 'PURCHASE' && name === 'TOTAL_SPEND') data = yield AnalyticsServices.getTotalSpend(params?.startDate, params?.endDate, params?.tenantIds);
    if (dataType === 'PURCHASE' && name === 'PURCHASE_BY_STATUS') data = yield AnalyticsServices.getPurchaseByStatus(params?.startDate, params?.endDate, params?.tenantIds, params?.sellerId);
    if (dataType === 'PURCHASE' && name === 'PURCHASE_BY_APPROVAL_STATUS') data = yield AnalyticsServices.getPurchaseByApprovalStatus(params?.startDate, params?.endDate, params?.tenantIds, params?.sellerId);
    if (dataType === 'PURCHASE' && name === 'PURCHASE_SCHEDULE') data = yield AnalyticsServices.getPurchaseSchedule(params?.startDate, params?.endDate, params?.tenantIds, params?.groupType);
    if (dataType === 'PURCHASE' && name === 'OVERDUE_GRN') data = yield AnalyticsServices.getOverdueGrn(params?.tenantIds);
    if (dataType === 'PURCHASE' && name === 'PR_BY_DEPARTMENT') data = yield AnalyticsServices.getPrByDepartment(params?.startDate, params?.endDate, params?.tenantIds);

    // Inventory
    if (dataType === 'INVENTORY' && name === 'STOCK_STATUS_SPLIT') data = yield AnalyticsServices.getInvStockStatusSplit(params.tenantIds);
    if (dataType === 'INVENTORY' && name === 'STOCK_VALUATION') data = yield AnalyticsServices.getInvStockValuation(params.tenantIds);
    if (dataType === 'INVENTORY' && name === 'OPEN_TRANSFERS') data = yield AnalyticsServices.getInvOpenStockTransfers(params.tenantIds);
    if (dataType === 'INVENTORY' && name === 'AGEING_SPLIT') data = yield AnalyticsServices.getInvAgeingSplit(params.tenantIds, params.interval, params?.steps);

    // Production
    if (dataType === 'PRODUCTION' && name === 'PRODUCTION_VALUE') data = yield AnalyticsServices.getProductionValue(params?.startDate, params?.endDate, params?.tenantIds, params?.method);
    if (dataType === 'PRODUCTION' && name === 'PRODUCTION_BY_STATUS') data = yield AnalyticsServices.getProductionByStatus(params?.startDate, params?.endDate, params?.tenantIds);
    if (dataType === 'PRODUCTION' && name === 'PRODUCTION_BY_MACHINE_STATUS') data = yield AnalyticsServices.getProductionByMachineStatus(params?.startDate, params?.endDate, params?.tenantIds);
    if (dataType === 'PRODUCTION' && name === 'OVERDUE_SCHEDULE_MO') data = yield AnalyticsServices.getOverdueScheduleMO(params?.startDate, params?.endDate, params?.tenantIds);
    if (dataType === 'PRODUCTION' && name === 'RESOURCE_WORKLOAD') data = yield AnalyticsServices.getResourceWorkLoadList(params.tenantIds);
    if (dataType === 'PRODUCTION' && name === 'ASSIGNEES_WORKLOAD') data = yield AnalyticsServices.getAssignessWorkLoadList(params.tenantIds);
    if (dataType === 'PRODUCTION' && name === 'PRODUCTION_OUTPUT') data = yield AnalyticsServices.getProductionOutput(params?.startDate, params?.endDate, params?.tenantIds);
    if (dataType === 'PRODUCTION' && name === 'PRODUCTION_DELIVERY_TIMELINESS') data = yield AnalyticsServices.getProductionDeliveryTimeliness(params?.startDate, params?.endDate, params?.tenantIds);
    if (dataType === 'PRODUCTION' && name === 'PRODUCTION_TREND') data = yield AnalyticsServices.getProductionTrend(params?.startDate, params?.endDate, params?.tenantIds);
    if (dataType === 'PRODUCTION' && name === 'PRODUCTION_PRODUCT_WISE') data = yield AnalyticsServices.getProductionProductWise(params?.startDate, params?.endDate, params?.tenantIds);

    // Sales
    if (dataType === 'SALES' && name === 'AVERAGE_ORDER_VALUE') data = yield AnalyticsServices.getAverageOrderValue(params);
    if (dataType === 'SALES' && name === 'ORDER_STATISTICS') data = yield AnalyticsServices.getOrderStatistics(params);
    if (dataType === 'SALES' && name === 'ON_TIME_DELIVERY') data = yield AnalyticsServices.getOnTimeDelivery(params);
    if (dataType === 'SALES' && name === 'ORDER_COUNT_BY_STATUS') data = yield AnalyticsServices.getOrderCountByStatus(params);
    if (dataType === 'SALES' && name === 'ORDER_TREND') data = yield AnalyticsServices.getOrderTrend(params);
    if (dataType === 'SALES' && name === 'ORDER_VALUE_BY_TYPE') data = yield AnalyticsServices.getOrderValueByType(params);
    if (dataType === 'SALES' && name === 'ORDER_VALUE_BY_CATEGORY') data = yield AnalyticsServices.getOrderValueByType(params);
    if (dataType === 'SALES' && name === 'ORDER_VALUE_BY_STATE') data = yield AnalyticsServices.getOrderValueByType(params);
    if (dataType === 'SALES' && name === 'ORDER_STATS_BY_CUSTOMER') data = yield AnalyticsServices.getOrderValueByCustomer(params);
    if (dataType === 'SALES' && name === 'ORDER_STATS_BY_PRODUCT') data = yield AnalyticsServices.getOrderValueByProduct(params);
    if (dataType === 'SALES' && name === 'ORDER_STATS_BY_SOURCE') data = yield AnalyticsServices.getOrderValueBySource(params);
    if (dataType === 'SALES' && name === 'ORDER_STATS_BY_SALES_PERSON') data = yield AnalyticsServices.getOrderValueBySalesPerson(params);
    if (dataType === 'SALES' && name === 'SALES_GROWTH_CUSTOMER_WISE') data = yield AnalyticsServices.getCustomerWiseGrowth(params);
    if (dataType === 'SALES' && name === 'ORDER_RECEIVABLES') data = yield AnalyticsServices.getOrderReceivables(params);

    yield put(AnalyticsActions.getAnalyticsDataSuccess(dataType, name, data?.data));
    yield put(AnalyticsActions.getAnalyticsDataLoading(dataType, name, false));
  } catch (error) {
    yield put(AnalyticsActions.getAnalyticsDataLoading(dataType, name, false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(analyticsActionTypes.GET_ANALYTICS_DATA.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getAnalytics() {
  yield takeEvery(analyticsActionTypes.GET_ANALYTICS_DATA.REQUEST, _getAnalytics);
}
function* _downloadDocument(action) {
  try {
    const state = yield select();
    const { user } = state?.UserReducers;
    const { payload, callback } = action;
    // Append user_id to the payload URL
    const updatedUrl = `${payload?.url}&user_id=${user?.user_id}`;

    // Notify loading state
    yield put(AnalyticsActions.downloadDocumentLoading(payload));

    // Download the document
    const downloadedDoc = yield AnalyticsServices.downloadDocument(updatedUrl);
    if (downloadedDoc) {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = `${payload?.document_type}_${payload?.document_number}`;
      link.href = URL.createObjectURL(
        new Blob([downloadedDoc], { type: downloadedDoc.type }),
      );
      link.click();
      if (callback) {
        callback();
      }
    }
    yield put(AnalyticsActions.downloadDocumentSuccess(payload?.key));
  } catch (error) {
    yield put(AnalyticsActions.downloadDocumentSuccess(action?.payload?.key));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* downloadDocument() {
  yield takeEvery(analyticsActionTypes.DOWNLOAD_DOCUMENT.REQUEST, _downloadDocument);
}

function* _printLabels(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(AnalyticsActions.printLabelsSuccess(null));
    yield put(AnalyticsActions.printLabelsLoading(true));
    const printedLabels = yield AnalyticsServices.printLabels(payload);
    if (printedLabels.success) {
      yield put(AnalyticsActions.printLabelsSuccess(printedLabels.html));
      notification.open({
        type: 'success',
        message: 'Labels Generated Successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(printedLabels.html);
      }
    } else {
      notification.open({
        type: 'error',
        message: 'Labels Generation Unsuccessful, Try Refreshing the Page',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(AnalyticsActions.printLabelsLoading(false));
  } catch (error) {
    yield put(AnalyticsActions.printLabelsLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* printLabels() {
  yield takeEvery(analyticsActionTypes.PRINT_LABELS.REQUEST, _printLabels);
}

function* _getBulkUploads(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(AnalyticsActions.getBulkUploadsLoading(true));
    const bulkUploads = yield AnalyticsServices.getBulkUploads(payload?.page, payload?.limit);
    if (bulkUploads?.success) {
      yield put(AnalyticsActions.getBulkUploadsSuccess(bulkUploads));
      if (callback) {
        callback();
      }
    }
    yield put(AnalyticsActions.getBulkUploadsLoading(false));
  } catch (error) {
    yield put(AnalyticsActions.getBulkUploadsLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getBulkUploads() {
  yield takeEvery(analyticsActionTypes.GET_BULK_UPLOADS.REQUEST, _getBulkUploads);
}

function* _commonGetRequest(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(AnalyticsActions.commonGetRequestsLoading(true));
    const getRequest = yield AnalyticsServices.commonGetRequests(payload?.url);
    if (getRequest.success) {
      notification.open({
        type: 'success',
        message: getRequest?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: getRequest?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) {
      callback();
    }
    yield put(AnalyticsActions.commonGetRequestsLoading(false));
  } catch (error) {
    yield put(AnalyticsActions.commonGetRequestsLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* commonGetRequest() {
  yield takeEvery(analyticsActionTypes.COMMON_GET_REQUEST.REQUEST, _commonGetRequest);
}

/**
 *
 */
export default function* activityLogSaga() {
  yield all([
    getAnalytics(),
    downloadDocument(),
    getBulkUploads(),
    commonGetRequest(),
    printLabels(),
  ]);
}
